import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  Breadcrumbs,
  DetailDrawer,
  InnoTable,
  Popover,
  TableList,
} from "InnoUI/components";
import InnoIcons from "InnoUI/innoicons";
import SC from "./style";
import theme from "theme";
import AddEditCompany from "./AddEditCompany";
import DeleteComponent from "../DeleteComponent";
import { Switch } from "antd";
import UserTable from "../Users/UserTable";
import { apiGet, apiPost } from "api/callApi";
import { innoTableConfigsecond, InnoTableDefaultPageSize } from "utils/config";
import { showAlert } from "utils/helper";

const Companies = (props) => {
  const { popupState } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [fieldData, setFieldData] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const [openModalView, setOpenModalView] = useState(false);
  const [openDeleteView, setOpenDeleteView] = useState(false);
  const [openUser, setOpenUser] = useState(false);
  const [fieldId, setFieldId] = useState();
  const [companyData, setCompanyData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageP, setCurrentPageP] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);

  const currentPath = location.pathname;

  const getCompanyData = async () => {
    try {
      const response = await apiGet(`/v1/getcompany`, false);
      setCompanyData(response.data);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getCompanyData();
  }, []);

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "Companies", href: "/admin-settings/companies" },
  ];

  const handleBreadcrumbClick = (href) => {
    if (href) {
      navigate(href);
    }
  };

  const openAddCompanyModal = () => {
    setOpenModalView(true);
  };

  const onRowClick = (data) => {
    setIsEditing(true);
    setOpenModalView(true);
    setFieldData(data);
    setFieldId(data.id);
  };

  const handleDelete = async (companyId) => {
    try {
      const body = {
        company: [companyId],
      };

      const response = await apiPost(`/v1/deletecompany`, body);
      showAlert({
        title: "Success",
        text: response.message || "Company updated successfully",
        icon: "success",
      });
      setOpenDeleteView(false);
      await getCompanyData();
      setFieldData(null);
    } catch (error) {
      console.log("Error", error);
    }
    // dispatch(deleteCompany({ companyId }));
  };

  const handleDeleteOpenModal = (record) => {
    setFieldId(record.id);
    setOpenDeleteView(true);
    setFieldData(record);
  };

  const handleChange = async (id, property, value) => {
    try {
      const payload = {
        companyId: id,
      };
      if (property === "status") {
        payload.status = value;
      } else if (property === "companyName") {
        payload.companyName = value;
      }
      const response = await apiPost(
        `/v1/editcompany/${payload.companyId}`,
        payload,
        false
      );
      await getCompanyData();
      showAlert({
        title: "Success",
        text: response.message || "Company updated successfully",
        icon: "success",
      });
    } catch (error) {
      console.error("Error updating company data:", error);
      showAlert({
        title: "Error",
        text: "Failed to update company data",
        icon: "error",
      });
    }
  };
  const handleUserCountClick = (row) => {
    setFieldData(row);
    setOpenUser(true);
  };
  const subColumnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 80,
      render(value, record, index) {
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <SC.ValueSpan>{serialNumber}</SC.ValueSpan>;
      },
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      sorter: (a, b) => a.companyName.localeCompare(b.companyName),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      width: 350,
      onCell: () => ({}),
      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Edit",
            // onClick: () => alert("In Progress"),
            onClick: () => onRowClick(record),
          },
          {
            id: 5,
            text: "Delete",
            onClick: () => handleDeleteOpenModal(record),
          },
        ];
        return (
          <SC.PopoverContainer>
            <SC.ValueSpan>{value}</SC.ValueSpan>
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <>
                    <div
                      style={{
                        width: "50px",
                        textAlign: "center",
                        justifyContent: "end",
                        display: "flex",
                        marginRight: "5px",
                      }}
                    >
                      <SC.PopoverSpan>
                        <SC.MoreVertIcon />
                      </SC.PopoverSpan>
                    </div>
                  </>
                ),
              }}
              popoverContent={
                <TableList
                  sx={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                  }}
                  items={menuItems || []}
                  popupState={popupState}
                />
              }
            />
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Number Of User",
      dataIndex: "userCount",
      align: "center",
      onCell: () => ({}),
      render(value, record) {
        return (
          <div style={{ textAlign: "center" }}>
            <span
              style={{
                color: "#eb7909",
                opacity: "0.7",
                textAlign: "center",
                cursor: "pointer",
                fontWeight: "bold",
              }}
              onClick={() => handleUserCountClick(record)}
            >
              <u>{value}</u>
            </span>
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (value, record) => (
        <Switch
          checked={value}
          onChange={(checked) =>
            handleChange(record.id, "status", checked ? 1 : 0)
          }
          style={{
            transform: "scale(0.7)",
            backgroundColor: value ? `${theme.colors.themeColor}` : undefined,
            borderColor: value ? `${theme.colors.themeColor}` : undefined,
          }}
        />
      ),
    },
  ];
  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: false,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
    addNew: true,
    search: true,
    action: false,
    divBorder: true,
    sno: false,
    searchPlaceholder: " Search by Name",
  };

  const usertableconfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: true,
    search: true,
    action: false,
    sno: false,
    divBorder: true,
    pagination: false,
  };

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={currentPath}
        onClick={handleBreadcrumbClick}
      />
      <SC.BodyContainer>
        <SC.Container>
          <InnoTable
            tableConfig={tableConfig}
            padding={"8px 8px 8px 8px"}
            column={subColumnData}
            data={companyData}
            tableKey={"Company"}
            onAddDataCallback={openAddCompanyModal}
            onRowClickCallback={onRowClick}
            ComponnentName={"Companies"}
            searchKeys={["companyName", "userCount"]}
          />
        </SC.Container>
      </SC.BodyContainer>
      {openModalView && (
        <AddEditCompany
          isEditing={isEditing}
          setOpenModalView={setOpenModalView}
          setIsEditing={setIsEditing}
          openModalView={openModalView}
          fieldData={fieldData}
          setFieldData={setFieldData}
          reloadData={getCompanyData}
        />
      )}
      {openDeleteView && (
        <DeleteComponent
          title={"Delete Company"}
          messageData={`Are you sure you want to Delete this Company ${
            fieldData?.companyName || ""
          }?`}
          setOpenDeleteView={setOpenDeleteView}
          openDeleteView={openDeleteView}
          handleDelete={() => handleDelete(fieldId)}
          handleArchive={() => setOpenDeleteView(false)}
          firstButtontext={"Cancel"}
        />
      )}
      {openUser && (
        <DetailDrawer
          open={openUser}
          onClose={() => {
            setOpenUser(false);
            setFieldData(null);
          }}
          closable={true}
          width={"60%"}
          children={
            <div>
              <SC.DrawerTitlesContainer>
                <SC.DrawerTitles>{fieldData?.companyName}</SC.DrawerTitles>
                <SC.CloseIcon>
                  <InnoIcons.CloseIcon
                    onClick={() => {
                      setOpenUser(false);
                      setFieldData(null);
                    }}
                  />
                </SC.CloseIcon>
              </SC.DrawerTitlesContainer>
              <UserTable
                tableConfig={usertableconfig}
                companyId={fieldData.id}
                hideColumns={["roleNames", "companyName", "createdAt"]}
                allowEdit={false}
                companyRowData={fieldData}
                currentPageP={currentPageP}
                setTotalData={setTotalData}
              />
            </div>
          }
        />
      )}
    </>
  );
};

export default Companies;
